module.exports = __webpack_public_path__ + "static/media/bg-prelogin-2.ea264436.jpg";